// const port = "https://lifeline-server.onrender.com"
// const port = "http://localhost:8001"
// const port = "https://lifeline-server-production.up.railway.app"
const port = "https://api.lifelinemedicalsupply.net"

export default port;